<h1 mat-dialog-title>Add Ledger Entry</h1>

<div mat-dialog-content class="dialog-content" [formGroup]="form">
  <mat-form-field appearance="fill">
    <mat-label>Entry Pattern</mat-label>
    <mat-select formControlName="pattern">
      @for (option of patternOptions; track option) {
        <mat-option [value]="option.value">
          {{option.label}}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <p class="pattern-hint">{{currentPatternHint}}</p>

  <div class="transaction-meta">
    <mat-form-field appearance="fill">
      <mat-label>Source</mat-label>
      <input matInput formControlName="source" />
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Description</mat-label>
      <input matInput formControlName="description" />
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>External Reference</mat-label>
      <input matInput formControlName="externalReference" />
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Posted At</mat-label>
      <input matInput type="date" formControlName="postedAt" />
    </mat-form-field>
  </div>

  @if (!isJournalPattern) {
    <div class="split-header">
      <mat-form-field appearance="fill" class="anchor-field">
        <mat-label>Main {{anchorSide | titlecase}} Account</mat-label>
        <mat-select formControlName="anchorAccountId">
          @for (account of sortedAccounts; track account) {
            <mat-option [value]="account.id">
              {{accountLabel(account)}}
            </mat-option>
          }
        </mat-select>
        @if (form.get('anchorAccountId')?.invalid && form.get('anchorAccountId')?.touched) {
          <mat-error>
            Main account is required
          </mat-error>
        }
      </mat-form-field>
      <div class="split-note">Split lines below are {{splitSide}} entries.</div>
    </div>
  }

  <div class="rows" formArrayName="rows">
    <div class="row-head">
      <span>Account</span>
      <span>Side</span>
      <span>Amount</span>
      <span>Memo</span>
      <span></span>
    </div>
    @for (row of rowGroups; track row; let i = $index) {
      <div class="row-item" [formGroupName]="i">
        <mat-form-field appearance="fill">
          <mat-select formControlName="accountId" placeholder="Account">
            @for (account of sortedAccounts; track account) {
              <mat-option [value]="account.id">
                {{accountLabel(account)}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        @if (isJournalPattern) {
          <mat-form-field appearance="fill">
            <mat-select formControlName="side" placeholder="Side">
              <mat-option value="debit">Debit</mat-option>
              <mat-option value="credit">Credit</mat-option>
            </mat-select>
          </mat-form-field>
        } @else {
          <div class="fixed-side">{{splitSide | titlecase}}</div>
        }
        <mat-form-field appearance="fill">
          <input matInput type="number" min="0.01" step="0.01" formControlName="amount" placeholder="0.00" />
        </mat-form-field>
        <mat-form-field appearance="fill">
          <input matInput formControlName="memo" placeholder="Optional memo" />
        </mat-form-field>
        <button mat-icon-button type="button" (click)="removeRow(i)" [disabled]="rowGroups.length <= (isJournalPattern ? 2 : 1)">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    }
  </div>

  <div class="row-actions">
    <button mat-stroked-button type="button" (click)="addRow()">
      {{isJournalPattern ? 'Add Line' : 'Add Split Line'}}
    </button>
  </div>

  @if (errorMessage) {
    <div class="error">{{errorMessage}}</div>
  }
  @if (!sortedAccounts.length) {
    <div class="empty">No accounts found. Create accounts first.</div>
  }
</div>

<div mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary" type="button" (click)="save()" [disabled]="!canSubmit">Post Entry</button>
</div>
